import type { CaptureResult } from '@cli-types/core-engine/utils.js'
import { runCapture } from '@cli-utils/process.js'
import { renderVerifyDatabaseReachableRequireFromProjectTemplate } from '@next-adapter/templates/renderers/commands/init/verify-database-reachable.js'
import { parseSeedError } from './parse-seed-error.js'
import { readExistingDbUrl } from './read-existing-db-url.js'

export async function verifyDatabaseReachable(cwd: string): Promise<CaptureResult> {
  const databaseUrl = readExistingDbUrl(cwd)
  if (!databaseUrl) {
    return {
      success: false,
      error: 'Database URL is missing or invalid',
      output: ''
    }
  }

  const result = await runCapture(
    process.execPath,
    ['-e', renderVerifyDatabaseReachableRequireFromProjectTemplate()],
    {
      cwd,
      timeoutMs: 15_000,
      env: {
        DATABASE_URL: databaseUrl.value
      }
    }
  )

  if (result.success) {
    return result
  }

  const error = parseSeedError(result.output, result.error)
  return {
    ...result,
    error
  }
}
